// ==================================================
//  ヤクルトあれこれ タブ
// ==================================================
document.addEventListener('DOMContentLoaded', () => {
  const tabItems = Array.from(document.querySelectorAll('.js-dataTabItem'));
  const contentItems = Array.from(document.querySelectorAll('.js-dataContentItem'));

  tabItems.forEach((tab, idx) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();

      // Remove active class from all tabs and contents
      tabItems.forEach((t) => t.classList.remove('is-active'));
      contentItems.forEach((c) => c.classList.remove('is-active'));

      // Add active class to the clicked tab and corresponding content
      tab.classList.add('is-active');
      if (contentItems[idx]) {
        contentItems[idx].classList.add('is-active');
      }
    });
  });
});

// ==================================================
//  ヤクルトランキング タブ
// ==================================================
document.addEventListener('DOMContentLoaded', () => {
  const tabItems = Array.from(document.querySelectorAll('.js-rankingTabItem'));
  const contentItems = Array.from(document.querySelectorAll('.js-rankingContentItem'));

  tabItems.forEach((tab, idx) => {
    tab.addEventListener('click', (e) => {
      e.preventDefault();

      // Remove active class from all tabs and contents
      tabItems.forEach((t) => t.classList.remove('is-active'));
      contentItems.forEach((c) => c.classList.remove('is-active'));

      // Add active class to the clicked tab and corresponding content
      tab.classList.add('is-active');
      if (contentItems[idx]) {
        contentItems[idx].classList.add('is-active');
      }
    });
  });
});
